export enum WhatsAppProvider {
  ShortNotify = 0,
  Meta = 1
};
